import * as types from "../types";

export const logoutRequest = () => ({
    type: types.LOGOUT_REQUEST,
})

export const logoutSuccess = () => ({
    type: types.LOGOUT_SUCCESS,
})

export const logoutFailure = () => ({
    type: types.LOGOUT_FAILURE,
})

export const nbfcLogoutRequest = () => ({
    type: types.NBFC_LOGOUT_REQUEST,
})

export const nbfcLogoutSuccess = () => ({
    type: types.NBFC_LOGOUT_SUCCESS,
})

